@use '@shared/styles/media' as media;

.page-not-found-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.error {
  font-size: 16rem;
  color: var(--tg-theme-button-color);
  text-shadow: var(--default-text-shadow);
}

@media (max-width: media.$maxWidthTablet) {
  .error {
    font-size: 8rem;
  }
}

@media (max-width: media.$maxWidthPhoneRotated) {
  .page-not-found-block {
    p {
      text-align: center;
    }
  }

  .error {
    font-size: 4rem;
  }
}
